module.exports = __webpack_public_path__ + "static/media/edit.daabf43d.svg";